import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { debounce } from "lodash-es";
import { SelectionProcessesService } from "@frontend/src/core/services/selection_processes_service";
import { commonsHelper } from "@frontend/helpers";
import FormEditResponsible from "./EditResponsibleForm";

const metadata = {
  currentPage: 1,
  nextPage: null,
  prevPage: null,
  totalPages: 1,
  totalCount: 0,
};

const ResponsibleModal = ({
  isOpen,
  handleOpen,
  selectionProcess,
  onSubmitResponsible,
}) => {
  const [userList, setUserList] = useState({
    data: [],
    pagination: metadata,
  });
  const [loading, setLoading] = useState(false);
  const [firstLoading, setFistLoading] = useState(false)
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const selectionProcessesService = new SelectionProcessesService();

  useEffect(() => {
    setFistLoading(true)
    handleGetAllUsers(
      userList.pagination.currentPage,
      selectionProcess?.responsible?.name
    );
  }, []);

  useEffect(() => {
    if (selectedUser) {
      setUserList((value) => ({
        data: [...value.data, selectedUser],
        pagination: value.pagination,
      }));
    }
  }, [selectedUser]);

  const handleGetAllUsers = (page, term) => {
    setLoading(true);
    selectionProcessesService
      .listUsers([], page, 10, term)
      .then(({ data, headers }) => {
        const mainData = {
          data,
          pagination: commonsHelper.buildMetadata(
            headers["current-page"],
            headers["total-pages"],
            headers["total-count"]
          ),
        };

        if (page > 1) {
          setUserList((value) => ({
            data: value.data.concat(mainData.data),
            pagination: mainData.pagination,
          }));
        } else {
          setUserList(mainData);
        }

        if (!term) {
          setUserList((value) => ({
            data: mainData.data,
            pagination: mainData.pagination,
          }));
        }

        setLoading(false);
        setFistLoading(false)
      });
  };

  const handleInfiniteScroll = ({
    target: { scrollHeight, scrollTop, clientHeight },
  }) => {
    const { nextPage } = userList.pagination;
    if (scrollHeight < scrollTop + clientHeight + 50 && nextPage && !loading) {
      searchTerm
        ? handleGetAllUsers(nextPage, searchTerm)
        : handleGetAllUsers(nextPage);
    }
  };

  const debouncedSearch = React.useCallback(
    debounce(handleGetAllUsers, 300),
    []
  );

  const onSearch = (term) => {
    setSearchTerm(term);
    term ? debouncedSearch(1, term) : setUserList(userList);
  };

  const handleSelect = (value) => {
    const selectedUserData = userList.data.find((item) => item.id === value);
    setSelectedUser(selectedUserData);
  };

  return (
    <Modal
      visible={isOpen}
      onCancel={() => handleOpen(false)}
      footer={false}
      title={selectionProcess ? selectionProcess.title : ""}
    >
      <FormEditResponsible
        onSubmitResponsible={onSubmitResponsible}
        handleInfiniteScroll={handleInfiniteScroll}
        onSearch={onSearch}
        handleSelect={handleSelect}
        selectionProcess={selectionProcess}
        loading={loading}
        firstLoading={firstLoading}
        userList={userList}
        handleCancel={() => handleOpen(false)}
      />
    </Modal>
  );
};

export default ResponsibleModal;
